import { Data } from "@angular/router";

export const SURPRISE_GIFT_FREE_CREDIT_ANIMATIONS = [
  "3_free_bonus_credit",
  "5_free_bonus_credit",
  "6_free_bonus_credit",
] as const;

/**
 * Surprise Gift interstitial only when this claim actually won a gift
 * (matches prize-summary card gate on gift_won_details.title) and the
 * animation key is a known free-credit gift animation.
 */
export function shouldNavigateToSurpriseGift(
  summary: Data | null | undefined,
  freeCreditAnimations: readonly string[] = SURPRISE_GIFT_FREE_CREDIT_ANIMATIONS
): boolean {
  if (!summary) {
    return false;
  }
  const hasGiftWin = !!(summary?.gift_won_details?.title || summary?.gift_won === true);
  const animation = summary?.gift_won_animation;
  return hasGiftWin && !!animation && freeCreditAnimations.includes(animation);
}

/**
 * Resolve credit amount for prize breakdown, preferring total_credit then
 * falling back to credit_won_sum used on the prize summary page.
 * Skips non-positive values so a preferred 0 does not hide a positive base/sum.
 */
export function resolveCreditWonAmount(prizeBreakdown: Data | null | undefined): number {
  if (!prizeBreakdown) {
    return 0;
  }
  const candidates = [
    prizeBreakdown?.preferred_currency?.total_credit?.value,
    prizeBreakdown?.base_currency?.total_credit?.value,
    prizeBreakdown?.preferred_currency?.credit_won_sum,
    prizeBreakdown?.credit_won_sum,
  ];
  for (const candidate of candidates) {
    const amount = Number(candidate);
    if (!Number.isNaN(amount) && amount > 0) {
      return amount;
    }
  }
  return 0;
}
